import React from 'react';

function MobileBottomNav({ view, setView, activeTab, setActiveTab }) {
  // 🚨 কালার প্যালেট 🚨
  const bgColor = '#012b72'; // Deep Blue Background
  const activeColor = '#ef5e33'; // Vibrant Orange for Active
  const inactiveColor = '#8ab4f8'; // Light Blue for Inactive

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999]">
      <style>
        {`
          /* 🚨 Extremely Compact Nav Container 🚨 */
          .nav-container {
            background-color: ${bgColor};
            border-top-left-radius: 20px;
            border-top-right-radius: 20px;
            box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.2);
            padding: 8px 10px; /* প্যাডিং একদম কমিয়ে দেওয়া হয়েছে */
            display: flex;
            justify-content: space-between;
            align-items: center; /* সব আইকন সমান লেভেলে থাকবে */
          }

          /* Nav Items & Bounce Animation */
          .nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 3px;
            cursor: pointer;
            flex: 1;
            position: relative;
            -webkit-tap-highlight-color: transparent;
            transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          }

          /* Pop on touch */
          .nav-item:active {
            transform: scale(0.85);
          }

          /* Glow effect for active icon */
          .nav-item.active svg {
            filter: drop-shadow(0px 2px 6px rgba(239, 94, 51, 0.6));
          }
        `}
      </style>

      <div className="nav-container">
        
        {/* 1. Buy Car (প্রথমে) */}
        <div className={`nav-item ${view === 'buy' ? 'active' : ''}`} onClick={() => setView('buy')}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill={view === 'buy' ? 'rgba(239,94,51,0.2)' : 'none'} stroke={view === 'buy' ? activeColor : inactiveColor} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a2 2 0 0 0-1.6-.8H9.3a2 2 0 0 0-1.6.8L5 11l-5.16.86a1 1 0 0 0-.84.99V16h3m12 0a2.5 2.5 0 1 1-5 0m5 0a2.5 2.5 0 1 0-5 0m-7 0a2.5 2.5 0 1 1-5 0m5 0a2.5 2.5 0 1 0-5 0"></path>
          </svg>
          <span style={{ fontSize: '9px', fontWeight: '900', color: view === 'buy' ? activeColor : inactiveColor }}>Buy</span>
        </div>

        {/* 2. Sell Car (দ্বিতীয়) */}
        <div className={`nav-item ${view === 'sell_car_new' ? 'active' : ''}`} onClick={() => { setView('sell_car_new'); if(setActiveTab) setActiveTab('Post Ad'); }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill={view === 'sell_car_new' ? 'rgba(239,94,51,0.2)' : 'none'} stroke={view === 'sell_car_new' ? activeColor : inactiveColor} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
            <line x1="7" y1="7" x2="7.01" y2="7"></line>
          </svg>
          <span style={{ fontSize: '9px', fontWeight: '900', color: view === 'sell_car_new' ? activeColor : inactiveColor }}>Sell</span>
        </div>

        {/* 3. Home (মাঝখানে) */}
        <div className={`nav-item ${view === 'home' ? 'active' : ''}`} onClick={() => setView('home')}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill={view === 'home' ? 'rgba(239,94,51,0.2)' : 'none'} stroke={view === 'home' ? activeColor : inactiveColor} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          <span style={{ fontSize: '9px', fontWeight: '900', color: view === 'home' ? activeColor : inactiveColor }}>Home</span>
        </div>

        {/* 4. Explore (চতুর্থ) */}
        <div className={`nav-item ${view === 'explore' ? 'active' : ''}`} onClick={() => setView('explore')}>
           <svg width="22" height="22" viewBox="0 0 24 24" fill={view === 'explore' ? 'rgba(239,94,51,0.2)' : 'none'} stroke={view === 'explore' ? activeColor : inactiveColor} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
          </svg>
          <span style={{ fontSize: '9px', fontWeight: '900', color: view === 'explore' ? activeColor : inactiveColor }}>Explore</span>
        </div>

        {/* 5. Account (পঞ্চম) */}
        <div className={`nav-item ${view === 'account' ? 'active' : ''}`} onClick={() => setView('account')}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill={view === 'account' ? 'rgba(239,94,51,0.2)' : 'none'} stroke={view === 'account' ? activeColor : inactiveColor} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
          </svg>
          <span style={{ fontSize: '9px', fontWeight: '900', color: view === 'account' ? activeColor : inactiveColor }}>Account</span>
        </div>

      </div>
    </div>
  );
}

export default MobileBottomNav;